var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fseg-layout',[_c('v-container',[_c('h3',[_vm._v(_vm._s(_vm.$t("fseg.welcome")))]),_c('dashboard-info',{directives:[{name:"auth",rawName:"v-auth:roles",value:(['WORKER']),expression:"['WORKER']",arg:"roles"}]}),_c('maintenance-info')],1),_c('release-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }